import { FC } from 'react';

import ImageProxy from '@next-image-proxy';

import {
  magicIdModalBubbles,
  magicIdModalGirl,
  magicIdModalGradient320px,
  magicIdModalGradient568px,
} from '@shared/assets/images/scope/magicId';

const CompleteMagicIdModalBottomDecoration: FC = () => (
  <div className="relative w-full h-[200px] sm:h-0 md:hidden">
    <picture className="w-full absolute bottom-0 rounded-bl-xl rounded-br-xl">
      <source
        srcSet={magicIdModalGradient568px.src}
        media="(min-width: 568px) and (max-width: 767px)"
      />
      <source srcSet={magicIdModalGradient320px.src} />
      <ImageProxy
        className="w-full absolute bottom-0 rounded-bl-xl rounded-br-xl"
        src={magicIdModalGradient320px}
        alt=""
      />
    </picture>

    <ImageProxy
      src={magicIdModalBubbles}
      className="absolute w-[200px] h-[200px] right-0 sm:hidden"
      width={200}
      height={200}
      alt=""
      quality={100}
    />

    <ImageProxy
      className="absolute w-[190px] h-[210px] bottom-[-30px] left-[-30px] sm:w-[130px] sm:h-[140px]"
      src={magicIdModalGirl}
      width={190}
      height={210}
      alt=""
      quality={100}
    />
  </div>
);

export default CompleteMagicIdModalBottomDecoration;
